// Ưu tiên runtime config qua window.__ENV__, sau đó tới CRA env, cuối cùng là fallback dev.
export function getBackendUrl() {
  // 1) Runtime (có thể đổi không cần rebuild)
  if (
    typeof window !== "undefined" &&
    window.__ENV__ &&
    window.__ENV__.PUBLIC_BACKEND_URL
  ) {
    return window.__ENV__.PUBLIC_BACKEND_URL;
  }

  // 2) CRA (được thay thế lúc build; cần prefix REACT_APP_)
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_PUBLIC_BACKEND_URL
  ) {
    return process.env.REACT_APP_PUBLIC_BACKEND_URL;
  }

  // 3) Fallback dev
  return process.env.REACT_APP_PUBLIC_BACKEND_URL || "http://localhost:3009";
}
